var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33095 0C7.46341 2.84655e-05 7.59286 0.0323812 7.70273 0.0929219C7.81261 0.153463 7.89792 0.239441 7.94777 0.339864C7.99761 0.440287 8.00973 0.550592 7.98255 0.656677C7.95538 0.762762 7.89017 0.859806 7.79524 0.935403L1.6073 5.99871L7.79524 11.062C7.85915 11.1122 7.91017 11.1724 7.94532 11.2389C7.98046 11.3054 7.99903 11.3771 7.99994 11.4495C8.00084 11.522 7.98405 11.5939 7.95057 11.6611C7.91708 11.7282 7.86756 11.7891 7.80492 11.8404C7.74228 11.8917 7.66776 11.9322 7.58574 11.9596C7.50372 11.987 7.41584 12.0007 7.32725 12C7.23866 11.9992 7.15115 11.984 7.06982 11.9553C6.9885 11.9265 6.91501 11.8848 6.85365 11.8325L0.194921 6.38394C0.0700932 6.28176 -3.00407e-05 6.14319 -3.00407e-05 5.99871C-3.00407e-05 5.85423 0.0700932 5.71567 0.194921 5.61348L6.85365 0.164946C6.91571 0.112752 6.98991 0.0712642 7.07189 0.0429335C7.15387 0.0146029 7.24196 4.25925e-06 7.33095 0Z",
    fill: "#BABEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevPage);
export default __webpack_public_path__ + "static/media/prev-page.29b3ad212e378f37c8063b04f61435a4.svg";
export { ForwardRef as ReactComponent };